var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54 0H8v6.46L6.46 8V3.785c0-.51.04-.94.078-1.292l-.013-.013c-.378.417-.848.887-1.305 1.33L1.24 7.792.209 6.761l3.98-3.981c.444-.457.914-.927 1.331-1.305l-.013-.013c-.352.039-.783.078-1.292.078H0z"
  })));
};
export default SvgArrowUpRight;